import { SbBlokData } from "@storyblok/react";
import { StoryblokRichTextDocumentNode } from "@storyblok/richtext";

import { Typography } from "@pondigitalsolutions/pon-component-library";
import { RichText } from "@components/RichText";
import { PageBody } from "./PageBody";

interface ContactsBlockProps {
  title?: string;
  description?: StoryblokRichTextDocumentNode;
  contacts: SbBlokData[];
}

export const ContactsBlock = ({
  title,
  description,
  contacts,
}: ContactsBlockProps) => {
  return (
    <div className="mt-10 bg-white p-4 lg:p-8 dark:bg-secondary-950">
      <div className="flex flex-col gap-1">
        {title && (
          <Typography
            as="h2"
            size="xl"
            className="leading-[150%] font-semibold text-secondary-700 dark:text-white"
          >
            {title}
          </Typography>
        )}
        {description && <RichText document={description} />}
      </div>
      {contacts && contacts.length > 0 && (
        <PageBody
          blok={contacts}
          className="mt-4 flex flex-col gap-6 lg:mt-8"
        />
      )}
    </div>
  );
};
